module.exports = __webpack_public_path__ + "static/media/lst_img_03.02738b17.png";